<template>
  <div class="newsDiv">
    <img src="../../assets/images/topline.png" class="topline" />
    <img src="../../assets/images/topline.png" class="topline2" />
    <div class="imgDiv">
      <img src="../../assets/images/news.png" class="imgtitle" />
    </div>
    <el-carousel
      :interval="1000000"
      type="card"
      height="400px"
      indicator-position="none"
    >
      <el-carousel-item v-for="(item, index) in imgArr" :key="index">
        <div style="width: 100%; height: 100%">
          <el-image
            style="
              width: 100%;
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              padding: 5px;
            "
            :src="item.img"
          ></el-image>
          <a @click="opento(item.url)" class="new-a"><img src="../../assets/images/btn.png" alt=""> </a>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  name: 'AboutUs',
  data () {
    return {
      imgArr: [
        { img: require('../../assets/images/news1.png'),url:'https://once.xmu.edu.cn/info/1165/1062.htm' },
        { img: require('../../assets/images/news2.png'),url:'https://once.xmu.edu.cn/info/1165/1045.htm' },
        { img: require('../../assets/images/news3.png'),url:'https://once.xmu.edu.cn/info/1165/1046.htm' },
      ],
    }
  },
  methods: {
    opento(url){
      // console.log(e);
      window.open(url)
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.new-a{
    position: absolute;
    top: 344px;
    right: 290px;
    img{
      width: 136px;
    }
}
.newsDiv {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  /deep/ .el-carousel--card {
    width: 90%;
  }

  .imgDIV {
    width: 100%;
    display: flex;
    align-items: center;
    .img {
      width: 100%;
    }
  }
}

.el-carousel__item:nth-child(2n) {
  background-color: #f4f8ff;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #f4f8ff;
}
.imgtitle {
  width: 187px;
  height: 80px;
}
.topline {
  width: 1px;
  height: 100px;
  margin: 0 auto;
  margin-bottom: 30px;
  position: absolute;
  top: -154px;
}
.topline2 {
  width: 1px;
  height: 100px;
  margin: 0 auto;
  margin-bottom: 30px;
  position: absolute;
  top: -26px;
}
.imgDiv {
  z-index: 70;
  width: 100%;
  position: absolute;
  top: -100px;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-around;
  // .line {
  //   height: 2px;
  //   width: 40%;
  // }
}
</style>
